export default __webpack_public_path__ + "static/media/where_am_i.2d941cdb.PNG";